<template>
  <div class="container">
    <div v-if="reloadBlocks">
      <AutomationFlowCard
        v-for="(item, index) in triggerAndSteps"
        :key="index"
        :header="item.header"
        :firstItem="index == 0"
        :id="item.id"
        :state="item.validateState"
        :selected="item.selected"
        :disabled="isFlowCardDisabled(item)"
        @select-item="selectBlock"
      >
        <template #body v-if="hasProperties(item)">
          <div>
            <AutomationFlowDetailsProperty
              v-for="(property, propertyIndex) in item.properties"
              :key="propertyIndex"
              :title="property.title"
              :value="property.value"
              :icon="property.icon"
              :iconSize="property.iconSize ? property.iconSize : 'md'"
              v-if="propertyIndex == 0"
            />
          </div>

          <CCollapse :show="Boolean(item.expandedDetails)">
            <AutomationFlowDetailsProperty
              v-for="(property, propertyIndex) in item.properties"
              :key="propertyIndex"
              :title="property.title"
              :value="property.value"
              :icon="property.icon"
              :iconSize="property.iconSize ? property.iconSize : 'md'"
              v-if="propertyIndex != 0"
            />
          </CCollapse>

          <div
            style="cursor: pointer"
            class="text-center mt-2 text-gray-600 font-weight-bold automation-card-details-separator pt-3"
            @click="expandBlock(item)"
          >
            {{ !item.expandedDetails ? $t('automation.flow.card.expand') : $t('automation.flow.card.expanded') }}
            <CIcon
              name="arrow"
              size="custom-size"
              :height="18"
              viewBox="0 0 32 32"
              class="ml-2"
              :class="item.expandedDetails ? 'automatin-card-details-icon-rotation' : ''"
            />
          </div>
        </template>
      </AutomationFlowCard>
    </div>
  </div>
</template>
<script>
import AutomationFlowCard from './AutomationFlowCard.vue'
import AutomationFlowDetailsProperty from './AutomationFlowDetailsProperty.vue'
import { TRIGGER_STEPS_STATES, STEP_TYPES, CHANNEL_TYPES } from '../../constants'
import { getDateFromISO } from '@/utils/dateUtil'

const formatTime = (date) => {
  date = getDateFromISO(date)
  let hours = date.getUTCHours()
  let minutes = date.getUTCMinutes()

  return `${hours >= 10 ? hours : '0' + hours}:${minutes >= 10 ? minutes : '0' + minutes}`
}

export default {
  components: {
    AutomationFlowCard,
    AutomationFlowDetailsProperty,
  },
  data() {
    return {
      reloadBlocks: true,
      triggerStepsStateEnum: TRIGGER_STEPS_STATES,
    }
  },
  created() {
    if (this.stepIndexHash !== undefined && this.stepIndexHash !== null) {
      this.checkRouteSelectedStep()
    }
  },
  computed: {
    triggerAndSteps() {
      let expandedStep = this.$store.state.automation.automationDetail.expanded
      let mainWorkflow = this.$store.state.automation.mainWorkflow

      let list = []
      list.push({
        id: 0,
        type: STEP_TYPES.AUTOMATION_DETAIL,
        selected: STEP_TYPES.AUTOMATION_DETAIL == this.$store.state.automation.currentStep?.currentStepType,
        header: this.$t('automation.flow.card.001.title'),
        validateState: this.checkValidationState(this.$store.state.automation.controls.validation.automationDetail),
        expandedDetails: expandedStep ?? false,
        properties: [
          {
            title: this.$t('automation.flow.card.001.items.001'),
            value: mainWorkflow.name,
            icon: 'cilTags',
          },
          {
            title: this.$t('automation.flow.card.001.items.002'),
            value: mainWorkflow.workflowJson.triggers.values[0]?.data?.dateFieldName,
            icon: 'cilPaperPlane',
          },
          {
            title: this.$t('automation.flow.card.001.items.003'),
            value: this.timeOffsetChange(mainWorkflow.workflowJson.triggers.values[0]?.data?.triggerOffsetInMinutes),
            icon: 'cilCalendar',
          },
          {
            title: this.$t('automation.flow.card.001.items.004'),
            value: formatTime(mainWorkflow.workflowJson.triggers.values[0]?.data?.triggerDate),
            icon: 'time',
            iconSize: 'sm',
          },
          {
            title: this.$t('automation.flow.card.001.items.005'),
            value: mainWorkflow.workflowJson.triggers.values[0]?.data?.timezone,
            icon: 'cilGlobeAlt',
          },
        ],
      })

      list.push({
        id: 1,
        type: STEP_TYPES.AUDIENCE,
        selected: STEP_TYPES.AUDIENCE == this.$store.state.automation.currentStep?.currentStepType,
        header: this.$t('automation.flow.card.002.title'),
        validateState: this.checkValidationState(this.$store.state.automation.controls.validation.audience),
      })

      list.push({
        id: 2,
        type: STEP_TYPES.ACTION,
        selected: STEP_TYPES.ACTION == this.$store.state.automation.currentStep?.currentStepType,
        header: this.$t('automation.flow.card.003.title'),
        validateState: this.checkValidationState(this.$store.state.automation.controls.validation.action),
      })

      list.push({
        id: 3,
        type: this.checkContentType(this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0]?.type),
        selected:
          this.checkContentType(this.$store.state.automation.mainWorkflow.workflowJson.steps?.values[0]?.type) ==
          this.$store.state.automation.currentStep?.currentStepType,
        header: this.$t('automation.flow.card.004.title'),
        validateState: this.checkValidationState(this.$store.state.automation.controls.validation.content),
      })

      return list
    },
    stepIndexHash() {
      const matchStepIndex = this.$route.hash.match(/\d+/);
      const stepIndex = matchStepIndex ? parseInt(this.$route.hash.replace(/\D/g, ""), 10) : null

      return stepIndex
    }
  },
  methods: {
    hasProperties(item) {
      if (item.properties && item.properties.length > 0) return true
      else return false
    },
    async selectBlock(index) {
      if (this.stepIndexHash !== index) {
        await this.$router.replace({ hash: index.toString() });
      }

      let selectedBlock = this.triggerAndSteps.find((elm) => elm.id == index)

      selectedBlock.selected = true

      this.$emit('select-block', selectedBlock.type)
    },
    expandBlock(item) {
      item.expandedDetails = !item.expandedDetails
      this.$store.commit('automation/EXPAND_BLOCK', item.expandedDetails)
    },
    checkValidationState(state) {
      switch (state) {
        case true:
          return TRIGGER_STEPS_STATES.VALID
        case false:
          return TRIGGER_STEPS_STATES.INVALID
        case null:
        case undefined:
        case NaN:
          return TRIGGER_STEPS_STATES.NOT_EDITED
        default:
          return TRIGGER_STEPS_STATES.NOT_VALIDATED
      }
    },
    checkContentType(channelType) {
      switch (channelType) {
        case CHANNEL_TYPES.SEND_EMAIL:
          return STEP_TYPES.CONTENT_EMAIL
        case CHANNEL_TYPES.SEND_SMS:
          return STEP_TYPES.CONTENT_SMS
        default:
          return STEP_TYPES.CONTENT_UNDEFINED
      }
    },
    timeOffsetChange(time) {
      if (time == 0) return 'Current Date'
      else return 'Date ' + time / 1440
    },
    isFlowCardDisabled(item) {
      if (item.type == STEP_TYPES.AUTOMATION_DETAIL) return false

      const previousSteps = this.triggerAndSteps.filter((step) => step.id < item.id)
      const hasPreviousStepsInvalid = previousSteps.some((step) => step.validateState !== this.triggerStepsStateEnum.VALID)

      if (item.type == STEP_TYPES.AUDIENCE) {
        const stepBlocker = this.triggerAndSteps.find((step) => step.type == STEP_TYPES.AUTOMATION_DETAIL)
        const isStepInvalid = stepBlocker.validateState !== this.triggerStepsStateEnum.VALID
        return isStepInvalid || hasPreviousStepsInvalid
      }

      if (item.type == STEP_TYPES.ACTION) {
        const stepBlocker = this.triggerAndSteps.find((step) => step.type == STEP_TYPES.AUDIENCE)
        const isStepInvalid = stepBlocker.validateState !== this.triggerStepsStateEnum.VALID
        return isStepInvalid || hasPreviousStepsInvalid
      }

      if (item.type == STEP_TYPES.CONTENT_EMAIL || item.type == STEP_TYPES.CONTENT_SMS || item.type == STEP_TYPES.CONTENT_UNDEFINED) {
        const stepBlocker = this.triggerAndSteps.find((step) => step.type == STEP_TYPES.ACTION)
        const isStepInvalid = stepBlocker.validateState !== this.triggerStepsStateEnum.VALID

        return isStepInvalid || hasPreviousStepsInvalid
      }
    },
    checkRouteSelectedStep() {
      const hashMatchedStep = this.triggerAndSteps.find((elm) => elm.id == this.stepIndexHash)
      if (!hashMatchedStep) return

      this.selectBlock(hashMatchedStep.id)
    }
  },
}
</script>
<style lang="scss">
.automation-card-details-separator {
  border-top: 1px $gray-300 solid;
}

.automatin-card-details-icon-rotation {
  transform: rotate(180deg);
}
</style>
